<template>
	<div class="wp100 oh">
		<div id="contributionIndex">
			<div class="disf jc-s ai-c pl10 mb5" style="height: 32px;">
				<p><i class="fs16 sz szminyizhengji mr5" style="color: #909399"></i>我的投稿</p>
				<div>
					<el-button style="background-color: #f93e61; color: #ffffff" size="small" icon="el-icon-circle-plus"
						class="fs14" @click="showDrawer(undefined)">稿件提交
					</el-button>
				</div>
			</div>

			<div class="wp100 bg-c-fff pb20"
				style="height: calc(100vh - 125px);overflow-y: auto; width: calc(100% + 13px);">
				<!-- 投稿须知 -->
				<div class="wp100 pl20 pr20 pt20">
					<div class="wp100 rad5 p20"
						style="border: 1px solid #EBEEF5;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid red">
							投稿须知
						</div>
						<p class="pl10 fs14 pr10 pt10">{{ notice }}</p>
					</div>
				</div>

				<!-- 投稿信息 -->
				<div class="wp100 pl20 pr20 pt20">
					<div class="wp100 rad5 p20 pb40"
						style="border: 1px solid #EBEEF5;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
						<div class="h30 pl10 lh30 fs16" style="border-left: 5px solid red">
							投稿信息
						</div>
						<div class="pl10">
							<div class="h40 dis-f">
								<div class="w100 fs12 h40 lh40 col-introduce">投稿类型</div>
								<div class="fs14 h40 lh40">高校师生</div>
							</div>
							<div class="h40 dis-f">
								<div class="w100 fs12 h40 lh40 col-introduce">文章名<span style="color: red;">*</span>
								</div>
								<div class="fs14 h40 lh40" v-if="this.contribution.Info.article_title != ''">
									{{ this.contribution.Info.article_title }}
								</div>
								<div class="fs14 col-gray h40 lh40">上传文章后自动获取</div>
							</div>
							<div class="h40 dis-f">
								<div class="w100 fs12 h40 lh40 col-introduce">副标题（如有）</div>
								<div class="fs14 h40 lh40 w300">
									<el-input placeholder="请输入副标题" v-model="contribution.Info.article_subtitle"
										clearable style="width: 300px;">
									</el-input>
								</div>
							</div>
						</div>

						<!-- 作者列表 -->
						<div class="h30 pl10 lh30 fs16 mt20" style="border-left: 5px solid red">
							作者信息
						</div>
						<div class="dis-f pl10">
							<div id="author1" class="mr40">
								<div class="h30 lh40 fs14">
									第一作者
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者名称</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="作者姓名" v-model="contribution.AuthorList[0].author"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者单位</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第一单位" v-model="contribution.AuthorList[0].author_unit_1"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">单位邮编</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第一单位邮编"
											v-model="contribution.AuthorList[0].author_postcode_1" clearable
											style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者单位</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第二单位" v-model="contribution.AuthorList[0].author_unit_2"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f">
									<div class="w100 fs12 h40 lh40 col-introduce">单位邮编</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第二单位邮编"
											v-model="contribution.AuthorList[0].author_postcode_2" clearable
											style="width: 300px;">
										</el-input>
									</div>
								</div>
							</div>
							<div id="author2">
								<div class="h30 lh40 fs14">
									第二作者
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者名称</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="作者姓名" v-model="contribution.AuthorList[1].author"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者单位</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第一单位" v-model="contribution.AuthorList[1].author_unit_1"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">单位邮编</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第一单位邮编"
											v-model="contribution.AuthorList[1].author_postcode_1" clearable
											style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f mb10">
									<div class="w100 fs12 h40 lh40 col-introduce">作者单位</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第二单位" v-model="contribution.AuthorList[1].author_unit_2"
											clearable style="width: 300px;">
										</el-input>
									</div>
								</div>
								<div class="h40 dis-f">
									<div class="w100 fs12 h40 lh40 col-introduce">单位邮编</div>
									<div class="fs14 h40 lh40 w300">
										<el-input placeholder="第二单位邮编"
											v-model="contribution.AuthorList[1].author_postcode_2" clearable
											style="width: 300px;">
										</el-input>
									</div>
								</div>
							</div>
						</div>

						<!-- 稿件上传 -->
						<div class="h30 pl10 lh30 fs16 mt20" style="border-left: 5px solid red">
							稿件信息
						</div>
						<div class="bg-c-fff mt10 pl40 fs14 wp100">
							<el-upload class="upload-demo" ref="upload" action="" accept=".doc,.docx"
								:before-remove="beforeRemove" :auto-upload="false" :limit="1" :on-exceed="handleExceed"
								:file-list="fileList" :on-change="getFile">
								<el-button size="small" type="primary"><i class="el-icon-upload pr5"></i>点击上传
								</el-button>
								<div slot="tip" class="el-upload__tip">
									附件支持DOC、DOCX格式 系统自动将附件名填为文章名
								</div>
							</el-upload>
						</div>


						<!-- 联系人信息 -->
						<div class="h30 pl10 lh30 fs16 mt20 dis-f jc-s" style="border-left: 5px solid red">
							<div>
								联系人
							</div>
							<el-button size="small" class="mr10 fs14" @click="openContact">选择联系人</el-button>
						</div>
						<div v-if="
					  contribution.Info.contact_info != undefined &&
					  contribution.Info.contact_info.contact_name != ''
					">
							<p class="pt5 pb10 fs14">
								<span style="color: rgb(144, 147, 153)"
									class="fs14 pr10">姓名</span>{{ contribution.Info.contact_info.contact_name }}
							</p>
							<p class="pb10">
								<span style="color: rgb(144, 147, 153)"
									class="fs14 pr10">联系方式</span>{{ contribution.Info.contact_info.contact_phone.phone }}
							</p>
							<p class="pb10">
								<span style="color: rgb(144, 147, 153)"
									class="fs14 pr10">邮箱</span>{{ contribution.Info.contact_info.contact_email }}
							</p>
							<p>
								<span style="color: rgb(144, 147, 153)" class="fs14 pr10">地址</span>{{ contribution.Info.contact_info.contact_province.proviceName
					  }}{{ contribution.Info.contact_info.contact_city.cityName
					  }}{{ contribution.Info.contact_info.contact_area.areaName
					  }}{{ contribution.Info.contact_info.contact_address }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<my-drawer title="编辑投稿" path="contribute/edit.vue" ref="editDrawer" :show-close="false" :withHeader="false"
			direction="rtl" size="80%" @editCallback="editCallback" append-to-body></my-drawer>
		<!-- 联系人编辑弹层 -->
		<my-dialog title="选择联系人" path="contribution/contact.vue" ref="chooseContact" width="700px" height="700px"
			@ok="afterChoose">
		</my-dialog>
	</div>
</template>

<script>
	import {
		getInfo
	} from "../../utils/token";
	import * as dataConfig from "../../data/config";
	export default {
		data() {
			return {
				contribution: {
					Id: {
						Id: 0,
					},
					CurrentDoc: {
						doc_name: "",
						doc_path: "",
					},
					Info: {
						id: {
							Id: 0,
						},
						cb_type: {
							cbType: 1,
						},
						article_title: "",
						article_subtitle: "",
						major_author_id: 0,
						contact_info: {
							contact_name: "",
							contact_phone: {
								phone: "",
							},
							contact_email: "",
							contact_province: {
								proviceId: 0,
								proviceName: "",
							},
							contact_city: {
								cityId: 0,
								cityName: "",
							},
							contact_area: {
								areaId: 0,
								areaName: "",
							},
							contact_address: "",
							contact_postcode: "",
						},
						member_id: 0,
						member_name: "",
						status: {
							cbStatus: 1,
						},
					},
					AuthorList: [{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
						{
							id: 0,
							author: "",
							author_unit_1: "",
							author_unit_2: "",
							author_postcode_1: "",
							author_postcode_2: "",
						},
					],
					DocList: [{
						id: 0,
						doc_path: "",
					}, ],
					DocFileName: "",
					DocFile: "",
				},
				notice: "",
				fileList: [],
				typeArray: dataConfig.memberType,
				contact_info: [],
				list: [],
				listCount: 0,
			};
		},

		mounted() {
			this.$api.contribute
				.index()
				.then((res) => {
					this.notice = res.Data.notice;
				})
				.catch((err) => {
					this.alertError(err.Data);
				});
		},

		methods: {
			// 打开编辑、添加联系人的弹层
			openContact() {
				this.$refs.chooseContact.show();
			},

			// 选择了会员联系方式的回调数据
			afterChoose(chooseContact) {
				console.log("选择的联系发放时", chooseContact);
				this.contribution.Info.contact_info.contact_name = chooseContact.name;
				this.contribution.Info.contact_info.contact_phone.phone =
					chooseContact.phone;
				this.contribution.Info.contact_info.contact_email = chooseContact.email;
				this.contribution.Info.contact_info.contact_province.proviceId =
					chooseContact.provice_id;
				this.contribution.Info.contact_info.contact_province.proviceName =
					chooseContact.provice_name;
				this.contribution.Info.contact_info.contact_city.cityId =
					chooseContact.city_id;
				this.contribution.Info.contact_info.contact_city.cityName =
					chooseContact.city_name;
				this.contribution.Info.contact_info.contact_area.areaId =
					chooseContact.areas_id;
				this.contribution.Info.contact_info.contact_area.areaName =
					chooseContact.areas_name;
				this.contribution.Info.contact_info.contact_address =
					chooseContact.address;
				this.contribution.Info.contact_info.contact_postcode =
					chooseContact.postcode;
			},

			// 上传文件获取文件信息和base64加密
			getFile(file, fileList) {
				this.contribution.DocFileName = file.raw.name;
				this.contribution.Info.article_title = file.raw.name.substring(0, file.raw.name.lastIndexOf('.'));
				this.getBase64(file.raw).then((res) => {
					// 这里是Base64结果
					this.contribution.DocFile = res.split(",")[1];
				});
			},
			getBase64(file) {
				return new Promise(function(resolve, reject) {
					let reader = new FileReader();
					let imgResult = "";
					reader.readAsDataURL(file);
					reader.onload = function() {
						imgResult = reader.result;
					};
					reader.onerror = function(error) {
						reject(error);
					};
					reader.onloadend = function() {
						resolve(imgResult);
					};
				});
			},

			// 删除上传的文件
			beforeRemove(file, fileList) {
				this.$confirm(`确定移除 ${file.name}？`).then(() => {
					this.contribution.DocFileName = "";
					this.contribution.DocFile = "";
					this.contribution.Info.article_title = "";
					this.fileList = [];
					return true;
				});
				return false;
			},

			// 选择的文件超出限制范围
			handleExceed(files, fileList) {
				this.$message.warning(`超出文章选择上限`);
			},

			// 打开抽屉
			showDrawer(contribute) {
				this.$refs.editDrawer.show(contribute);
			},

			//保存提交
			submitForm() {
				if (this.contribution.type == undefined) {
					this.alertError("请选择投稿类型");
					return;
				} else if (this.contribution.AuthorList[0].author == "") {
					this.alertError("请填写第一作者");
					return;
				} else if (this.contribution.AuthorList[0].author_unit_1 == "") {
					this.alertError("请填写第一作者单位");
					return;
				} else if (this.contribution.AuthorList[0].author_postcode_1 == "") {
					this.alertError("请填写单位邮编");
					return;
				} else if (this.contribution.DocFileName == "") {
					this.alertError("请上传投稿文件");
					return;
				}

				console.log("提交的数据", this.contribution);

				this.$api.contribute
					.contributionSubmit(this.contribution)
					.then((res) => {
						this.alertSuccess("提交成功");
						Object.assign(this.$data, this.$options.data());
						this.init();
					})
					.catch((err) => {
						this.alertError(err.Data);
					});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.el-tab-pane {
		padding-top: 10px;
	}

	.body {
		padding: 20px 200px;
	}

	.bodys {
		padding: 20px 600px;
	}

	.body-l {
		width: 40%;
		border: 1px solid #efefef;
		// padding: 10px;
		margin: 40px;
	}

	.body-r {
		width: 40%;
		border: 1px solid #efefef;
		margin: 40px;
	}

	.el-input {
		width: 40%;
	}

	.btns {
		margin: 0 auto;
		padding: 40rpx;
		background: #5084f3;
		background-color: #5084f3;
		color: #fff;
		box-shadow: 0 1px 10rpx 1rpx rgba(0, 0, 0, 0.1);
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: 450px;
	}

	.bor {
		border: 10px solid #15d8cb;
	}

	.pannel-title {
		height: 20px;
		line-height: 20px;
		padding-left: 10px;
		font-weight: bold;
	}

	.col-introduce {
		color: #909399;
	}
</style>
